export default __webpack_public_path__ + "static/media/image2M.656ba741.png";